export enum FunctionFlag {
  REQUEST_EXCLUDE = 'REQUEST_EXCLUDE',
  DUTY_OVERLAP_ALLOWED = 'DUTY_OVERLAP_ALLOWED',
  FUNCTION_GROUP = 'FUNCTION_GROUP',
  BUH_BLOCKED = 'BUH_BLOCKED',
  LEAVE_BLOCKED = 'LEAVE_BLOCKED',
  SALARY_BLOCKED = 'SALARY_BLOCKED',
  CAPPLAN_EXCLUDE = 'CAPPLAN_EXCLUDE',
  BONUS_BLOCKED = 'BONUS_BLOCKED',
  INCLUDE_IN_KIDS_RATIO = 'INCLUDE_IN_KIDS_RATIO'
}

export interface AdminFunction {
  code: string;
  valid: {
    from: string;
    to: string;
  };
  functionId?: number;
  codeExt: string;
  flags: string[];
  description: string;
  colorCode: string;
  costKind: number;
  parentFunctionDescription?: string | null;
  parentFunctionId?: number | null;
}
